import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { RouteSegment } from '@core/enums/route-segment.enum';
import { dashboardEnabledCanActivateGuard } from '@core/guards/dashboard-enabled-guard';
import { desktopOnlyCanActivateGuard } from '@core/guards/desktop-only-guard';
import { createPermissionGuard } from '@core/guards/permission-guard';
import { createSitesDefaultRedirectCommand$ } from '@core/guards/sites-default-redirect';
import { CUSTOM_TITLE_MARKER } from '@core/services/title.service';

import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';

import { MultiSiteDashboardComponent } from './multi-site-dashboard.component';
import { MultiSiteDashboardEffects } from './store/multi-site-dashboard.effects';
import { multiSiteDashboardFeatureKey, multiSiteDashboardReducer } from './store/multi-site-dashboard.reducer';

export const MultiSiteDashboardRoutes: Routes = [
  {
    path: RouteSegment.Root,
    component: MultiSiteDashboardComponent,
    canActivate: [
      dashboardEnabledCanActivateGuard,
      createPermissionGuard(
        [PermissionStoreModelEnum.ViewAnyDashboard, PermissionStoreModelEnum.ViewOwnDashboard],
        createSitesDefaultRedirectCommand$
      ),
      desktopOnlyCanActivateGuard(() => inject(Router).createUrlTree(['/', RouteSegment.Sites])),
    ],
    providers: [
      provideState({
        name: multiSiteDashboardFeatureKey,
        reducer: multiSiteDashboardReducer,
      }),
      provideEffects(MultiSiteDashboardEffects),
    ],
    title: CUSTOM_TITLE_MARKER,
  },
  {
    path: '**',
    redirectTo: RouteSegment.Root,
  },
];
